import { env } from '@/env';

export function getAssetUrl(
  id: string,
  options?: { width?: number; height?: number },
) {
  const url = new URL(`/assets/${id}`, env.NEXT_PUBLIC_API_BASE_URL);

  if (options?.width) {
    url.searchParams.set('width', options.width.toString());
  }

  if (options?.height) {
    url.searchParams.set('height', options.height.toString());
  }

  url.searchParams.set('format', 'auto');

  return url.toString();
}
